import type { FaireProductEntity } from "../../entity_types/product";

export const p_phz9z22vvv: FaireProductEntity = {
  token: "p_phz9z22vvv",
  type: "product",
  name: "Vintage Anemousite Inlaid Bronze Flower Shape Ring - CS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/623d2e03bf32d32d175af423bad770226ff09e0c2bcea6bec22d5a66dafed1c4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e14db10c59b4afeb9d4c18a8573da87319200d429be462e0ff01751f400f3236.jpeg",
    "https://cdn.faire.com/fastly/6f1803a6d6c911d45796f4c40d3de218a369a23ed6df9303423cae1521906d9b.jpeg",
    "https://cdn.faire.com/fastly/a8dcdf03a9e7725c28c88dcb51439d3cb1eae5b50b274f643503edea42c7c85a.jpeg",
  ],
  priceDollars: 9.26,
  description:
    "\nKind reminder: Stones and crystals are made of natural raw stones, and some stones have cracks, which is a normal phenomenon\n\n\nType: Ring\n\nMaterial : Stone,Copper alloy \nSize : 7#~8# ,adjustable \n\n★Made of high quality material, Nickel-free / Lead-free, Harmless to Human Body.\n\n\n★Perfect jewelry gifts\n",
  tags: [],
  msrpDollars: 18.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:14.615Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
